

export interface TransitionEligibility {
  catalogItemId: string
  title: string
  description: string
  quantity: number
  eligibilities: TransitionEligibilityDetail[]
}

export interface TransitionEligibilityDetail {
  isEligible: boolean
  transitionType: TransitionType
  errors: any[]
}

export enum TransitionType {
  TRANSITION_ONLY = 'transition_only',
  TRANSITION_WITH_LICENSE_TRANSFER = 'transition_with_license_transfer'
}

export interface TransitionError {

}
